import React from 'react';

// Styles & Assets
import styles from './PatientContactInfo.module.css';
import { IoMdCall } from 'react-icons/io';
import { RiSmartphoneLine } from 'react-icons/ri';
import locationIcon from '../../../assets/icons/location-icon.svg';
import chatIcon from '../../../assets/icons/chat-icon.svg';
import { ReactComponent as EditSvg } from '../../../assets/icons/edit-fill.svg';

// Services
import { getAddress } from '../../../services/getPatientAtribute';

// Hooks
import { useState, useContext } from 'react';

// Context
import GeneralContext from '../../../context/GeneralContext';
import { useChatContext } from '../../../context/ChatContext';

// Components
import DialogEditContactInfo from '../DialogEditContactInfo/DialogEditContactInfo';
import Modal from '../../UI/Modal/Modal';

// Interfaces
import { Patient } from '../../../interfaces/Patient';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';
import PatientInfoTitle from '../PatientInfoTitle/PatientInfoTitle';

const PatientContactInfo: React.FC<{
    patient: Patient
    handleCloseModal: () => void
}> = ({ patient, handleCloseModal }) => {

    const { t } = useTranslation();

    const [showEditContactInfoDialog, setShowEditContactInfoDialog] = useState(false);
    
    const generalContext = useContext(GeneralContext);
    const { hasUnreadMessages, setPatientId } = useChatContext();

    const handleClickChat = () => {
        handleCloseModal();
        setPatientId(patient.id);
        generalContext?.setIsChatOpen?.(true);
    };

    const address = getAddress(patient);

    return (
        <div>
            <PatientInfoTitle
                title={t('contact_info')}
                onClick={() => setShowEditContactInfoDialog(true)}
                size={32}
            >
                <EditSvg />
            </PatientInfoTitle>
            <div className={styles.patientInfoContainer}>
                <div className={styles.rowInfo}>
                    <p className={styles.titleContactInfo}>{t('phones')}:</p>
                    <div className={styles.info}>
                        {patient.mobile_phone &&
                            <p><RiSmartphoneLine /> {patient.mobile_phone}</p>
                        }
                        {patient.home_phone &&
                            <p><IoMdCall /> {patient.home_phone}</p>
                        }
                    </div>
                    <button className={styles.iconWrapper} onClick={handleClickChat}>
                        <img src={chatIcon} className={styles.iconChat} alt='icon chat' />
                        {hasUnreadMessages && <span className={styles.notificationDot}></span>}
                    </button>
                </div>
                <div className={styles.rowInfo}>
                    <p className={styles.titleContactInfo}>{t('email')}:</p>
                    <p className={styles.info}>{patient.email}</p>
                </div>
                <div className={styles.rowInfo}>
                    <p className={styles.titleContactInfo}>{t('address')}:</p>
                    <p className={styles.info}>{address}</p>
                    {patient.addresses.length > 0 ?
                        <Link className={styles.linkMaps} to={`https://www.google.com/maps/search/?api=1&query=${address}`} target="_blank">
                            <img src={locationIcon} className={styles.icon} alt='location icon' />
                        </Link> : ''
                    }
                </div>
            </div>
            <Modal show={showEditContactInfoDialog} setShowModal={setShowEditContactInfoDialog} secondModal>
                <DialogEditContactInfo
                    setShowModal={setShowEditContactInfoDialog}
                />
            </Modal>
        </div >
    );
};

export default PatientContactInfo;